import { Text, Image } from '@lounge-fe/ui-kit'
import classNames from 'classnames'
import { UpsellsItemProps } from './types'
import { ProductForm } from '../ProductForm'
import { Price } from '../Price'
import { useState } from 'react'
import { ProductPagePriceRange } from '../ProductPagePriceRange'
import { LiquidProductVariant } from '@/features/product/types/LiquidProduct'

export const Item = ({
  id,
  title,
  color,
  image,
  price,
  compare_at_price,
  variant_min_price: variantMinPrice,
  variant_max_price: variantMaxPrice,
  has_price_override: hasPriceOverride,
  secondaryImage,
  options,
  handle,
  variants,
  linkedBottoms,
  hide_out_of_stock_form: hideOutOfStockForm,
  onSuccess,
}: UpsellsItemProps): JSX.Element => {
  const [selectedVariant, setSelectedVariant] = useState<
    LiquidProductVariant | undefined
  >()

  const hasVariablePrice =
    variantMinPrice && variantMaxPrice && variantMinPrice !== variantMaxPrice

  const activePrice = (!hasPriceOverride && selectedVariant?.price) || price
  const compareAtPrice = selectedVariant?.compare_at_price || compare_at_price

  const url = `/products/${handle}`

  return (
    <div className="flex flex-col border-b border-primary-default last:border-b-0 pb-6 gap-3 sm:gap-4">
      <div className="flex flex-col gap-1">
        <Text variant="title-five">
          <a href={url}>
            {title} - <span className="text-[#888888]">{color}</span>
          </a>
        </Text>
        {hasVariablePrice && !selectedVariant ? (
          <ProductPagePriceRange
            minPrice={variantMinPrice / 100}
            maxPrice={variantMaxPrice / 100}
          />
        ) : (
          <Price
            price={activePrice / 100}
            compareAtPrice={compareAtPrice && compareAtPrice / 100}
          />
        )}
      </div>
      <a className="flex gap-1" href={url}>
        {image && (
          <div className="bg-surface-primary-default aspect-square block w-full">
            <Image
              {...image}
              className={classNames(
                'object-cover w-full h-full aspect-[1/1]',
                image.className,
              )}
            />
          </div>
        )}
        {secondaryImage && (
          <div className="bg-surface-primary-default aspect-square block w-full">
            <Image
              {...secondaryImage}
              className={classNames(
                'object-cover w-full h-full aspect-[1/1]',
                secondaryImage.className,
              )}
            />
          </div>
        )}
      </a>
      <ProductForm
        product={
          {
            id,
            title,
            color,
            image,
            price,
            compareAtPrice,
            handle,
          } as UpsellsItemProps
        }
        onSuccess={onSuccess}
        hasOnlyDefaultVariant={false}
        options={options}
        variants={variants}
        linked_bottoms={linkedBottoms}
        onVariantSelection={setSelectedVariant}
      />
    </div>
  )
}
